module.exports = __webpack_public_path__ + "static/img/logo_032.68f4713a.png";